// extracted by mini-css-extract-plugin
export default {"tr":"collectionpropertytable_tr__6CoNb"};